export default "__VITE_ASSET__7fcf8475__"